import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["photoInput", "submitButton"]

  handlePhotoChange(event) {
    // This is now just a hook for future use if needed
    // The preview is handled by the dropzone controller
  }

  submit(event) {
    event.preventDefault()
    
    // Disable submit button
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.innerHTML = "Adding..."

    // Create FormData
    const formData = new FormData(event.target)

    // Submit form
    fetch(event.target.action, {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      },
      credentials: "same-origin"
    })
    .then(response => response.text())
    .then(html => {
      if (html.includes("error")) {
        // Re-enable submit button on error
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.innerHTML = "Add Face"
        
        // Show error message
        const errorJson = JSON.parse(html)
        alert(errorJson.error)
      } else {
        // Reset form on success
        event.target.reset()
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.innerHTML = "Add Face"

        // Process Turbo Stream response
        Turbo.renderStreamMessage(html)
      }
    })
    .catch(error => {
      console.error("Error:", error)
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.innerHTML = "Add Face"
      alert("An error occurred. Please try again.")
    })
  }
} 